/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import '~styles/modules/sectioncontainer.scss';

const SectionContainer = ({ id, content, title }) => {

	return(
	
	   <div className="content-sections" id={id} data-content={id+"-cor-content"}>
	   		<div className="section-titles" id={id+"-content-title"}><span>{title}</span></div>
	      <div className="content-containers" id={id+"-cor-content"}>
	        {content}
	      </div>
	  </div>
	 )
};

export default SectionContainer;




